import React from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { Badge } from '@/components/lemmala-design-system/badge/badge'

import { DropdownSelectContext } from './dropdown-select-context'
import { DropdownSelectItem } from './dropdown-select.types'

interface DropdownSelectItemContentProps {
  item: DropdownSelectItem
}

export const DropdownSelectItemContent = ({ item }: DropdownSelectItemContentProps) => {
  const context = React.useContext(DropdownSelectContext)

  if (item.type === 'badge') {
    return (
      <Badge variant='attention' size='default' badgeStyle='subtle'>
        {item.label}
      </Badge>
    )
  }

  const isMulti = context?.multi
  const isDraggable = context?.draggable

  // Dynamic max-width logic:
  // - 36: default (single select, no drag)
  // - For multi-select, parent CheckboxWithLabel handles max-width
  // - 28: multi + draggable (extra space for drag handle)
  const maxWidth = isMulti && isDraggable ? 'max-w-28' : isMulti ? '' : 'max-w-36'

  return (
    <div className='flex items-center gap-2'>
      {item.icon && <span className='flex items-center'>{item.icon}</span>}
      <span className='flex min-w-0 items-center gap-1.5'>
        <span
          className={cn(
            maxWidth,
            'truncate text-body-default',
            item.disabled && 'text-main-foreground-disabled',
            !item.disabled && 'text-main-foreground-primary',
          )}
        >
          {item.label}
          {item.labelSuffix && (
            <span className='text-main-foreground-tertiary'> {item.labelSuffix}</span>
          )}
        </span>
        {item.suffixIcon && <span className='flex shrink-0 items-center'>{item.suffixIcon}</span>}
      </span>
    </div>
  )
}

DropdownSelectItemContent.displayName = 'DropdownSelectItemContent'
